import FaqCollapsedSection from '@quicktools/shared-components/components/landingPages/FaqExpandedSection/FaqExpandedSection';
import { Trans, useTranslation } from 'react-i18next';

function FaqSection() {
  const { t } = useTranslation();

  const faqQuestions = Array.from(Array(4)).map((_, index) => ({
    question: t(`landing.faqSection.questions.${index}.question`),
    answer: (
      <Trans i18nKey={`landing.faqSection.questions.${index}.answer`} components={{ a: <a /> }} />
    ),
    answerSchema: t(`landing.faqSection.questions.${index}.answer`),
  }));

  return (
    <FaqCollapsedSection
      title={t('landing.faqSection.title')}
      description={<Trans i18nKey="landing.faqSection.paragraph" components={{ a: <a /> }} />}
      questions={faqQuestions}
    />
  );
}

export default FaqSection;
